var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLapHoSoDangKy020744D5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4354",
    "data-name": "Ellipse 4354",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#f5f8fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.909,
    y1: 1,
    x2: 0.294,
    y2: -0.021,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bd2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7edfe"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_75924",
    x: -0.874,
    y: 39.82,
    width: 58.794,
    height: 68.15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#66afff",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_34521",
    x: 43.002,
    y: 29.121,
    width: 35.471,
    height: 35.471,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#66afff",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.074,
    y1: 0.282,
    x2: 0.918,
    y2: 0.762,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8983e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffba30",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LapHoSoDangKy",
    transform: "translate(-447.5 -310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53135",
    "data-name": "Group 53135",
    transform: "translate(11260.5 5832)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4349",
    "data-name": "Ellipse 4349",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(-10813 -5522)",
    fill: "#f5f9fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-10813 -5522)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53124",
    "data-name": "Group 53124",
    transform: "translate(14.465 21.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22756",
    "data-name": "Rectangle 22756",
    width: 51.072,
    height: 63.579,
    rx: 4,
    transform: "translate(0 0)",
    fill: "#007aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22757",
    "data-name": "Rectangle 22757",
    d: "M1,0H50.072a1,1,0,0,1,1,1V3.254a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V1A1,1,0,0,1,1,0Z",
    transform: "translate(0 0)",
    fill: "#71b5ff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5152",
    "data-name": "Line 5152",
    y2: 13.107,
    transform: "translate(26.057 4.091)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4352",
    "data-name": "Ellipse 4352",
    cx: 2.085,
    cy: 2.085,
    r: 2.085,
    transform: "translate(23.973 13.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4353",
    "data-name": "Ellipse 4353",
    cx: 2.085,
    cy: 2.085,
    r: 2.085,
    transform: "translate(23.973 1.042)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53125",
    "data-name": "Group 53125",
    transform: "translate(8.126 45.82)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.13, -45.82)",
    filter: "url(#Path_75924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75924-2",
    "data-name": "Path 75924",
    d: "M.438,2.668A2.549,2.549,0,0,1,2.986.119H29.67A2.549,2.549,0,0,1,31.5.9l9.012,9.334A2.549,2.549,0,0,1,41.231,12V47.72a2.549,2.549,0,0,1-2.549,2.549H2.986A2.549,2.549,0,0,1,.438,47.72Z",
    transform: "translate(7.69 45.7)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22758",
    "data-name": "Rectangle 22758",
    width: 25.015,
    height: 4.169,
    rx: 2.085,
    transform: "translate(7.296 7.465)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22759",
    "data-name": "Rectangle 22759",
    width: 15.634,
    height: 4.169,
    rx: 2.085,
    transform: "translate(7.296 14.688)",
    fill: "#6bd2ff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22760",
    "data-name": "Rectangle 22760",
    width: 25.015,
    height: 4.169,
    rx: 2.085,
    transform: "translate(7.296 24.31)",
    fill: "#6bd2ff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22761",
    "data-name": "Rectangle 22761",
    width: 25.015,
    height: 4.169,
    rx: 2.085,
    transform: "translate(7.296 31.606)",
    fill: "#6bd2ff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_34521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34521-2",
    "data-name": "Path 34521",
    d: "M16.471,0,10.588,16.471,8.161,8.688,0,5.882Z",
    transform: "translate(52.5 52.09) rotate(-90)",
    fill: "#6bd2ff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Component_154_10",
    "data-name": "Component 154 \\u2013 10",
    transform: "translate(501.5 364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4387",
    "data-name": "Ellipse 4387",
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#ffba30",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75998",
    "data-name": "Path 75998",
    d: "M51.414,26.118,39.61,19.5,38,31.484,46.049,35.6Z",
    transform: "translate(-25.838 -12.524)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53205",
    "data-name": "Group 53205",
    transform: "translate(6.797 6.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75999",
    "data-name": "Path 75999",
    d: "M29.439,19a1.431,1.431,0,0,0-1.431,1.431V23.65a.358.358,0,0,1-.358.358H24.431a1.431,1.431,0,1,0,0,2.862H27.65a.358.358,0,0,1,.358.358v3.219a1.431,1.431,0,0,0,2.862,0V27.228a.358.358,0,0,1,.358-.358h3.219a1.431,1.431,0,1,0,0-2.862H31.228a.358.358,0,0,1-.358-.358V20.431A1.431,1.431,0,0,0,29.439,19Z",
    transform: "translate(-23 -19)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapHoSoDangKy020744D5);
export default __webpack_public_path__ + "static/media/LapHoSoDangKy.020744d5.ea6cea848291a4cb15f739e411ab1ea3.svg";
export { ForwardRef as ReactComponent };